<!-- Compiled at 2026-10-07T06:21:14.844Z -->
<ng-container *ngIf="$isVariablesInitialized()">
	<ng-container *lowgileScope="null; screen: this; let $scope">
		<ng-container *lowgileForm="null; screen: this; let $formDirective">
			<div style="display: contents" [class.fill]="false">
				<Toolbox-MainLayout
					[$formDirective]="$formDirective"
					[$disabled]="$disabled"
					[$ignoreValidations]="$ignoreValidations"
					[screenTitle]="'Goal setting ' + (screen.gs ? `${screen.gs.cycle.getDateRange()} for ${screen.gs.employee.name}` : '')"
					[isForExternalUser]=""
				>
					<ng-template
						data-content-area="content"
						let-$scope="$scope"
						let-$formDirective="$formDirective"
						let-$disabled="$disabled"
					>
						<ng-container *lowgileScope="null; screen: this; let $scope">
							<div
								data-content-area="content"
								data-defined-in="Toolbox.GoalSettingEdit"
							>
								<div
									class="layout-block vertical"
									[style.align-items]="'inherit'"
									[style.gap]="'1em'"
								>
									<ng-container *ngIf="screen.gs"
										><ng-container *ngIf="screen.isHr"
											><div
												class="layout-block"
												[style.align-items]="'inherit'"
												[class.horizontal]="Sys.Layout.sizeIsGreaterThanOrEqual.XSmall"
												[class.vertical]="Sys.Layout.sizeIsLessThan.XSmall"
												[style.gap]="'1em'"
											>
												<mat-form-field
													class="has-selectionChange-handler"
													appearance="fill"
													(selectionChange)="handler_DropdownBlock_76_selectionChange_updateColumnVisibility_0($event, { $disabled: $disabled })"
												>
													@let $fc_76_1 = getFormControl(screen,
													'viewMode', 76, $scope, $formDirective,
													$disabled, $ignoreValidations);

													<mat-label
														[innerHtml]="'View goal setting as' | escapeHtml"
													></mat-label>
													<mat-select
														class="has-selectionChange-handler"
														(selectionChange)="handler_DropdownBlock_76_selectionChange_updateColumnVisibility_0($event, { $disabled: $disabled })"
														[formControl]="$fc_76_1"
														[compareWith]="$compare"
														#select_76="matSelect"
														[lgFormComponent]="select_76"
														[lgFormValue]="screen.viewMode"
														canSelectNullableOptions
														[multiple]="false"
													>
														@let emptyOption_76 = null; @if
														(emptyOption_76) {
														<mat-option [value]="emptyOption_76[0]"
															>{{ emptyOption_76[1] }}</mat-option
														>
														}

														<mat-option
															*ngFor="let $option of (Toolbox.GoalSettingViewMode.getChoices('$displayValue')); let $index = index"
															[value]="Toolbox.GoalSettingViewMode.getEntry($option.id)"
														>
															<span
																[innerHtml]="$option.label | escapeHtml"
																style="margin: auto 0"
															></span>
														</mat-option>
													</mat-select>
												</mat-form-field>
												<mat-form-field
													*ngIf="$any(screen.viewMode)?.$isOther"
												>
													@let $fc_76_3 = getFormControl(screen.viewMode,
													'$otherValue', 76, $scope, $formDirective,
													$disabled, $ignoreValidations);
													<mat-label
														[innerHtml]="'View goal setting as' + ' (Other)' | escapeHtml"
													></mat-label>
													<input
														type="text"
														matInput
														[formControl]="$fc_76_3"
													/>
												</mat-form-field>

												<ng-container
													*ngrxLet="(!devBarService.isEnableEverything()) && ($disabled || !!(!screen.isEditMode)) as $disabled"
												>
													<ng-container
														*ngrxLet="(!devBarService.isEnableEverything()) && ($disabled || !!(true)) as $disabled"
													>
														<mat-form-field
															class="has-selectionChange-handler"
															appearance="fill"
															(selectionChange)="handler_DropdownBlock_77_selectionChange_updateColumnVisibility_0($event, { $disabled: $disabled })"
														>
															@let $fc_77_1 =
															getFormControl(screen.gs, 'status', 77,
															$scope, $formDirective, $disabled,
															$ignoreValidations);

															<mat-label
																[innerHtml]="'Status' | escapeHtml"
															></mat-label>
															<mat-select
																class="has-selectionChange-handler"
																(selectionChange)="handler_DropdownBlock_77_selectionChange_updateColumnVisibility_0($event, { $disabled: $disabled })"
																[formControl]="$fc_77_1"
																[compareWith]="$compare"
																#select_77="matSelect"
																[lgFormComponent]="select_77"
																[lgFormValue]="screen.gs.status"
																canSelectNullableOptions
																[multiple]="false"
															>
																@let emptyOption_77 = null; @if
																(emptyOption_77) {
																<mat-option
																	[value]="emptyOption_77[0]"
																	>{{ emptyOption_77[1]
																	}}</mat-option
																>
																}

																<mat-option
																	*ngFor="let $option of (Toolbox.GoalSettingStatus.getChoices('$displayValue')); let $index = index"
																	[value]="Toolbox.GoalSettingStatus.getEntry($option.id)"
																>
																	<span
																		[innerHtml]="$option.label | escapeHtml"
																		style="margin: auto 0"
																	></span>
																</mat-option>
															</mat-select>
														</mat-form-field>
														<mat-form-field
															*ngIf="$any(screen.gs.status)?.$isOther"
														>
															@let $fc_77_3 =
															getFormControl(screen.gs.status,
															'$otherValue', 77, $scope,
															$formDirective, $disabled,
															$ignoreValidations);
															<mat-label
																[innerHtml]="'Status' + ' (Other)' | escapeHtml"
															></mat-label>
															<input
																type="text"
																matInput
																[formControl]="$fc_77_3"
															/>
														</mat-form-field>
													</ng-container>
													<button
														mat-raised-button
														class="has-click-handler"
														color="basic"
														(click)="handler_ButtonBlock_83_click_$adhoc_0($event, { $disabled: $disabled })"
														[disabled]="$disabled"
													>
														<span
															[innerHtml]="'Reopen at self-review' | escapeHtml: 'none' | replaceNewlines: 'span'"
														></span>
													</button>
													<button
														mat-raised-button
														class="has-click-handler"
														color="basic"
														(click)="handler_ButtonBlock_81_click_$adhoc_0($event, { $disabled: $disabled })"
														[disabled]="$disabled"
													>
														<span
															[innerHtml]="'Reopen at manager review' | escapeHtml: 'none' | replaceNewlines: 'span'"
														></span>
													</button>
													<button
														mat-raised-button
														class="has-click-handler"
														color="basic"
														(click)="handler_ButtonBlock_80_click_$adhoc_0($event, { $disabled: $disabled })"
														[disabled]="$disabled"
													>
														<span
															[innerHtml]="'Reopen at goal setting' | escapeHtml: 'none' | replaceNewlines: 'span'"
														></span>
													</button>
													<button
														mat-raised-button
														class="has-click-handler"
														color="basic"
														(click)="handler_ButtonBlock_82_click_$adhoc_0($event, { $disabled: $disabled })"
														[disabled]="$disabled"
													>
														<span
															[innerHtml]="'Reopen at manager approval' | escapeHtml: 'none' | replaceNewlines: 'span'"
														></span>
													</button>
												</ng-container></div
										></ng-container>

										<ng-container
											*ngrxLet="(!devBarService.isEnableEverything()) && ($disabled || !!(!screen.isEditMode)) as $disabled"
										>
											<Toolbox-GoalSettingInclude
												[$formDirective]="$formDirective"
												[$disabled]="$disabled"
												[$ignoreValidations]="$ignoreValidations"
												[gs]="screen.gs"
												[viewMode]="screen.viewMode"
												[columnVisibility]="screen.columnVisibility"
											>
											</Toolbox-GoalSettingInclude> </ng-container
									></ng-container>

									<ng-container *ngIf="screen.isHr"
										><div
											class="layout-block"
											[style.align-items]="'inherit'"
											[class.horizontal]="Sys.Layout.sizeIsGreaterThanOrEqual.XSmall"
											[class.vertical]="Sys.Layout.sizeIsLessThan.XSmall"
											[style.gap]="'1em'"
										>
											<ng-container *ngIf="screen.isEditMode; else else68"
												><button
													mat-raised-button
													class="has-click-handler"
													color="primary"
													(click)="handler_ButtonBlock_72_click_$adhoc_0($event, { $disabled: $disabled })"
													[disabled]="$disabled"
												>
													<mat-icon>{{'save'}}</mat-icon
													><span
														[innerHtml]="'Save' | escapeHtml: 'none' | replaceNewlines: 'span'"
													></span></button
											></ng-container>
											<ng-template #else68>
												<button
													mat-raised-button
													class="has-click-handler"
													color="primary"
													(click)="handler_ButtonBlock_71_click_$adhoc_0($event, { $disabled: $disabled })"
													[disabled]="$disabled"
												>
													<mat-icon>{{'edit'}}</mat-icon
													><span
														[innerHtml]="'Edit' | escapeHtml: 'none' | replaceNewlines: 'span'"
													></span>
												</button>
											</ng-template></div
									></ng-container>
								</div>
							</div>
						</ng-container>
					</ng-template>
				</Toolbox-MainLayout>
			</div>
		</ng-container>
	</ng-container>
</ng-container>
